import { render, staticRenderFns } from "./WeedSearch.vue?vue&type=template&id=54a76d92&"
import script from "./WeedSearch.vue?vue&type=script&lang=ts&"
export * from "./WeedSearch.vue?vue&type=script&lang=ts&"
import style0 from "./WeedSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports